import type { ConceptDef } from '../types';

const turn = (id: string, name: string, scene: string, parts: string[], description: string): ConceptDef => ({
  kind: 'rotateFind',
  id,
  label: name,
  category: 'Receptive',
  description,
  config: { scene, parts, startView: 'front', promptMode: 'AUDIO', errorless: 'off' },
});

export const turnCar = turn('turn-car', 'Turn and Find (3D): Car', 'car3d', ['wheel', 'door', 'bonnet', 'boot', 'headlight', 'plate', 'exhaust'], 'Turn the 3D car round to find the boot, the number plate, the exhaust…');
export const turnHouse = turn('turn-house', 'Turn and Find (3D): House', 'house3d', ['frontdoor', 'backdoor', 'chimney', 'garage', 'tree', 'letterbox', 'window'], 'Turn the 3D house round to find the back door, the garage, the tree…');
export const turnPlane = turn('turn-plane', 'Turn and Find (3D): Aeroplane', 'plane3d', ['wing', 'tail', 'cockpit', 'propeller', 'wheels', 'door'], 'Turn the 3D aeroplane round to find the tail, the wheels underneath…');
